import { TabViewModelImpl } from '../../../../toolkit/tabs/tab/tabviewmodel';
import { ListViewModel } from '../../../../toolkit/horizontallist/listviewmodel';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { BaseContext } from '../../../../../utils/basecontext';
import * as React from 'react';
import { SearchTabComponentHandler } from '../searchcomponent';
import { ArtistTabSearchListComponent } from './artistsearchlistcomponent';
import { PaginationListViewModel } from '../../../../toolkit/verticallist/paginationverticallist/paginationlistviewmodel';

export class ArtistTabSearchListTabViewModelImpl extends TabViewModelImpl
{
    private ref: ArtistTabSearchListComponent;
  
    constructor(private context: BaseContext, private title: string, 
        private listViewModel: ListViewModel<ToneDto>,private searchTabHandler: SearchTabComponentHandler)
    {
        super();
    }

    getTitle(): string 
    {
        return this.title;
    }

    getTabView(): JSX.Element
    {
        // this.listViewModel.setListDatas(this.getListOfTones());
        return <ArtistTabSearchListComponent ref={(item: any) => this.ref = item} onLoadMore={this.searchTabHandler.onLoadMore} listViewModel={this.listViewModel} context={this.context}/>;
    }
    
    updateTabData(listOfDatas: ToneDto[])
    {
        this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas);

        this.resetPaginationCount();
        this.ref !== null && this.ref.forceUpdateComponent();
    }

    updateLoadMoreTabData(listOfDatas: ToneDto[])
    {
        this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas);

        this.ref !== null && this.ref.forceUpdateComponent();
    }

    deleteData(id: string)
    {
        this.listViewModel.deleteData(id);

        this.ref !== null && this.ref.forceUpdateComponent();
    }

    resetPaginationCount()
    {
        (this.listViewModel as PaginationListViewModel<ToneDto>).resetPaginationState();

        this.ref !== null && this.ref.resetPaginationCount();
    }

    updatePaginationCount()
    {
        this.ref !== null && this.ref.updatePaginationCount();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/artist/artistsearchlisttabviewmodel.tsx